import { RelationshipType } from "@models/consent.model";

export const UNKNOWN_COMPANY_ID = 'N/A'; // Special ID for custom companies

// Relationship options (same for all user types).
// Fallback shown until/unless the stakeholder roles API answers; its wording is also the display text for mapped roles.
export const relationshipOptions = [
    {
        label: 'Occupier',
        value: RelationshipType.OCCUPIER,
        description: 'I am the occupant of this property.'
    },
    {
        label: 'Energy Bill Payer',
        value: RelationshipType.BILL_PAYER,
        description: 'I pay the energy bills for this property.'
    },
    {
        label: 'Landlord (freeholder or leaseholder)',
        value: RelationshipType.LANDLORD,
        description: 'I am the freeholder or leaseholder of this property and have legitimate interest.'
    }
];

/** A role as returned by GET /v1/stakeholder-roles/public (only the fields used here). */
export interface StakeholderRoleDto {
    code: string;
    description?: string;
}

/**
 * Stakeholder role code -> the relationship type the wallet sends to the backend.
 * A role the wallet has no relationship type for (e.g. one added later in the admin dashboard)
 * is skipped, because there is no API value to submit for it.
 */
export const STAKEHOLDER_ROLE_RELATIONSHIP: Record<string, RelationshipType> = {
    ENERGY_CONSUMER: RelationshipType.OCCUPIER,
    ENERGY_BILL_PAYER: RelationshipType.BILL_PAYER,
    PROPERTY_OWNER: RelationshipType.LANDLORD,
};

/** Builds the radio options from the roles the admin dashboard marks visible in Consent Wallet (API order kept). */
export function relationshipOptionsFromRoles(roles: StakeholderRoleDto[]): typeof relationshipOptions {
    const options: typeof relationshipOptions = [];
    for (const role of roles) {
        const value = STAKEHOLDER_ROLE_RELATIONSHIP[role.code];
        const fallback = relationshipOptions.find(o => o.value === value);
        if (!fallback || options.some(o => o.value === value)) continue;
        options.push({ ...fallback, description: role.description?.trim() || fallback.description });
    }
    return options;
}
